import React from "react";
import InputLabel from "@mui/material/InputLabel";
import classNames from "classnames";
import "./label.scss";

const Label = (props) => {
  const classes = classNames("label", props.className);
  return (
    <InputLabel {...props} className={classes}>
      {props.children}
    </InputLabel>
  );
};

export default Label;
